import initialState from './initialState';

export default function mainReducer(state = initialState.main, action) {
	switch(action.type) {
        case 'IS_VALID_URL':
            return{
                ...state,
                isValidUrl: true
            }

        case 'IS_INVALID_URL':
            return{
                ...state,
                isValidUrl: false
            }

		case 'IS_VIDEO_TEST':
			return{
				...state,
                isVideoTest: true
			}

        case 'IS_NOT_VIDEO_TEST':
            return{
                ...state,
                isVideoTest: false
            }

		case 'APP_LOADING_FALSE':
			return {
				...state,
				loading: false
			}

		case 'SET_PARTICIPANT_INFO':
			return {
				...state,
				council: action.value
			}

		case 'LOADING_FALSE':
			return {
				...state,
				started: true
			}

		default:
			return {
				...state
            };
	}
}



// WEBPACK FOOTER //
// ./src/store/reducers/main.js